<template>
    <feed-card
        :feed="source"
        :universes="otherPropValue.universes"
        :events="otherPropValue.events"
        :configurations="relatedConfigurations"
        :defaultPreviewImageUrl="otherPropValue.defaultPreviewImageUrl"
        :unMutedFeedsUid="otherPropValue.unMutedFeedsUid"
        :dashboard-card="false"
    ></feed-card>
</template>

<script>
import { FeedCard } from 'gcmcn-common';
export default {

    components: {
        FeedCard,
    },


    props: {
        index: {
            type: Number,
            required: true,
        },
        source: {
            type: Object,
            default () {
                return {};
            }
        },
        otherPropValue: {
            type: Object,
        }
    },

    data (){
        return {

        };
    },

    computed: {
        relatedConfigurations (){
            return this.otherPropValue.configurations.filter((conf) => conf.feed_uid === this.source.uid );
        },
    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-card.vue